import { UnknownAction } from '@reduxjs/toolkit';
import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  AuthActionTypes,
  UserLoggedInAction,
} from '../types/redux/actions';
import { AuthState } from '../types/redux/state';

const initialState: AuthState = {
  isAuthenticated: false,
};

const authReducer = (state = initialState, action: AuthActionTypes | UnknownAction): AuthState => {
  switch (action.type) {
    case USER_LOGGED_IN:
      return {
        isAuthenticated: true,
        user: (action as UserLoggedInAction).payload,
      };
    case USER_LOGGED_OUT:
      return {
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;
